import React from "react";
import { RichTextElement } from "@kontent-ai/gatsby-components";
import { useDisclaimerData } from "@staticQueries/disclaimerQuery";
import { LinkedImage } from "@global";
import { Container } from "@ui";

const MasterDisclaimer = () => {
  const data = useDisclaimerData();
  return (
    <section className="border-b-[5px] border-salmon bg-snowWhite pb-8 pt-10 text-slateBrown md:pb-10 md:pt-14">
      <Container>
        <small className="font-body text-sm tracking-[0.28px] [&_*]:mb-5 [&_a]:underline [&_figure]:my-auto [&_figure]:mr-6 [&_figure]:inline-block [&_figure]:align-middle last:[&_figure]:mr-0 last:[&_p]:mb-0">
          <RichTextElement
            value={data.value}
            linkedItems={data.modular_content}
            resolveLinkedItem={(linkedItem: any, domNode: any) => {
              const isLinkedImage = domNode.attribs["data-rel"] === "component";
              return (
                <>
                  {isLinkedImage && (
                    <LinkedImage
                      image={linkedItem.elements.image}
                      url={linkedItem.elements.url}
                    />
                  )}
                </>
              );
            }}
          />
        </small>
      </Container>
    </section>
  );
};

export default MasterDisclaimer;
